/*
 * W3C tabs.js and mobile tabs (expanders) working together introduced some issues, this plugin fixes them
 */
(function($) {
    $.fn.tabToExpanderHelper = function() {
        var mq = window.matchMedia('(max-width: 991px)');

        this.each(function() {
            var $this = $(this),
                currentMode = 'desktop',

                widthChange = function() {
                    if (mq.matches) {
                        if (currentMode === 'desktop') {
                            switchToMobileMode();
                        }
                    } else {
                        if (currentMode !== 'desktop') {
                            switchToDesktopMode();
                        }
                    }
                },

                switchToMobileMode = function() {
                    $this.addClass(isActive() ? 'collapse show' : 'collapse');
                    currentMode = 'mobile';
                },

                switchToDesktopMode = function() {
                    $this.removeClass('collapse show');
                    currentMode = 'desktop';
                },

                isActive = function() {
                    return $this.attr('hidden') === undefined;
                };

            if (matchMedia) {
                mq.addListener(widthChange);
                widthChange(mq);
            }
        });

        return this;
    };
}(jQuery));
